import type { CheckboxTreeItem } from '~/modules/artist-roster/components/CheckboxTree/types.ts';
import type { LabelHierarchy } from '~/modules/artist-roster/types';

export function mapLabelHierarchyToCheckboxTreeItem(
  items: LabelHierarchy[],
  labelIdSet?: Set<number>,
): CheckboxTreeItem[] {
  if (items.length === 0) {
    return [];
  }

  return items.map((item) => {
    const mappedChildren = mapLabelHierarchyToCheckboxTreeItem(
      item.child_labels,
      labelIdSet,
    );
    let children: CheckboxTreeItem[] | undefined;

    if (item.child_labels.length > 0) {
      children = mappedChildren;
    }

    return {
      id: item.label_id.toString(),
      label: item.name,
      checked: labelIdSet?.has(item.label_id) ?? false,
      isVisible: true,
      isExpanded: false,
      children,
    };
  });
}
